/**
 * English legal copy — generated by Claude Sonnet 4.5 from the final
 * Italian source and reviewed by the product owner before wiring.
 * See /app/drafts/legal_translations/en.md for the original draft.
 */

const en = {
    terms: {
        preamble: [
            { type: "para", text: 'Other Side is a digital platform operated by Laura Stella, doing business as "Other Side".' },
        ],
        sections: [
            { number: 1, title: "Nature of the service", blocks: [
                { type: "para", text: "Other Side uses artificial intelligence technologies to generate simulated experiences based on content provided by users." },
                { type: "para", text: "The generated interactions do not represent real communications, nor do they imply the presence or consciousness of the person represented." },
            ]},
            { number: 2, title: "Requirements for use", blocks: [
                { type: "para", text: "You must be at least 18 years old and use the service in compliance with applicable laws." },
            ]},
            { number: 3, title: "Responsibility for content", blocks: [
                { type: "para", text: "You are responsible for the content you upload and declare that you have the right to use it." },
            ]},
            { number: 4, title: "Represented persons", blocks: [
                { type: "para", text: "You guarantee that you will not violate third-party rights, including rights relating to deceased persons." },
            ]},
            { number: 5, title: "Prohibited use", blocks: [
                { type: "para", text: "Using the service for illegal, fraudulent, or harmful purposes that infringe on others' rights is prohibited." },
            ]},
            { number: 6, title: "Limitation of liability", blocks: [
                { type: "para", text: "Other Side is not responsible for subjective interpretations, emotional reactions, or improper use of the service." },
            ]},
            { number: 7, title: "Interruption", blocks: [
                { type: "para", text: "The service may be suspended or limited in case of violations." },
            ]},
            { number: 8, title: "Your rights", blocks: [
                { type: "para", text: "You may request access to, modification of, or deletion of your data." },
            ]},
            { number: 9, title: "Changes", blocks: [
                { type: "para", text: "These terms may be updated at any time." },
            ]},
            { number: 10, title: "Applicable law", blocks: [
                { type: "para", text: "The service is governed by applicable European regulations." },
            ]},
        ],
    },

    privacy: {
        preamble: [
            { type: "contact", label: "Data Controller", value: 'Laura Stella, doing business as "Other Side"' },
            { type: "contact", label: "Email", value: "os.otherside.app@gmail.com", mailto: true },
        ],
        sections: [
            { number: 1, title: "Types of data collected", blocks: [
                { type: "list", items: [
                    "Identifying data",
                    "Uploaded content (images, audio, video)",
                    "Biometric data (voice, images)",
                    "Technical data (IP, device, logs)",
                ]},
            ]},
            { number: 2, title: "Purposes", blocks: [
                { type: "list", items: [
                    "Service provision",
                    "AI content generation",
                    "Security and improvement",
                ]},
            ]},
            { number: 3, title: "Legal basis", blocks: [
                { type: "list", items: [
                    "Explicit consent",
                    "Service execution",
                ]},
            ]},
            { number: 4, title: "Biometric data", blocks: [
                { type: "para", text: "Biometric data is processed only with your explicit consent." },
            ]},
            { number: 5, title: "Retention", blocks: [
                { type: "para", text: "Data is retained for the time necessary to provide the service." },
            ]},
            { number: 6, title: "Your rights", blocks: [
                { type: "para", text: "Access, rectification, deletion, limitation, objection." },
            ]},
            { number: 7, title: "Transfers", blocks: [
                { type: "para", text: "Data may be processed on servers located in the European Union or outside it, in compliance with applicable regulations." },
            ]},
            { number: 8, title: "Security", blocks: [
                { type: "para", text: "Technical and organizational measures are implemented to protect data." },
            ]},
            { number: 9, title: "Complaints", blocks: [
                { type: "para", text: "You may contact the competent supervisory authority." },
            ]},
        ],
    },

    biometric: {
        preamble: [
            { type: "para", text: "You give explicit consent to the processing of:" },
        ],
        sections: [
            { title: "Biometric data involved", blocks: [
                { type: "list", items: ["images", "voice", "audio and video content"] },
                { type: "para", text: "for the purpose of creating the digital experience." },
            ]},
            { title: "Nature of consent", blocks: [
                { type: "para", text: "This consent is:" },
                { type: "list", items: ["freely given", "informed", "revocable"] },
            ]},
            { title: "Revocation", blocks: [
                { type: "para", text: "You may revoke it at any time through your account settings or by direct request." },
            ]},
        ],
    },

    ai_notice: {
        preamble: [
            { type: "para", text: "Other Side uses artificial intelligence systems." },
        ],
        sections: [
            { title: "The interactions", blocks: [
                { type: "list", items: [
                    "are artificially generated",
                    "may simulate voice, style, and content",
                    "do not represent real communications",
                ]},
            ]},
            { title: "Limits of the system", blocks: [
                { type: "para", text: "The service does not recreate consciousness or real identity." },
                { type: "para", text: "You agree to interact with an AI system and understand its limitations." },
            ]},
        ],
    },

    memorial: {
        preamble: [
            { type: "para", text: "Other Side allows the creation of experiences based on content relating to persons." },
        ],
        sections: [
            { number: 1, title: "Responsibility", blocks: [
                { type: "para", text: "You are responsible for the content you upload." },
            ]},
            { number: 2, title: "Deceased persons", blocks: [
                { type: "para", text: "You declare that you have the right or authorization to use the content." },
            ]},
            { number: 3, title: "Rights of family members", blocks: [
                { type: "para", text: "Requests for removal or modification may be made by authorized parties." },
            ]},
            { number: 4, title: "Reports", blocks: [
                { type: "para", text: "Other Side reserves the right to remove disputed content." },
            ]},
            { number: 5, title: "Limitations", blocks: [
                { type: "para", text: "The service does not guarantee historical accuracy or real representation." },
            ]},
        ],
    },
};

export default en;
